// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { AstatDailyLocalTaxInfoFragmentFragment } from '../../fragments/generated/astat-daily-local-tax-info.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetAstatDailyLocalTaxInfoQueryVariables = Types.Exact<{
  getAstatDailyLocalTaxInfoRequestDTO: Types.GetAstatDailyLocalTaxInfoRequestDtoInput;
}>;


export type GetAstatDailyLocalTaxInfoQueryResult = { __typename?: 'Query', getAstatDailyLocalTaxInfo: { __typename?: 'AstatDailyLocalTaxInfoDTO', month: number, monthClosed: boolean, totalArrivals: number, totalDepartures: number, totalGuestsPresent: number, totalTaxAdults: number, totalTaxChildren: number, totalTaxExempted: number, year: number } };

export const GetAstatDailyLocalTaxInfoGql = gql`
    query GetAstatDailyLocalTaxInfo($getAstatDailyLocalTaxInfoRequestDTO: GetAstatDailyLocalTaxInfoRequestDTOInput!) {
  getAstatDailyLocalTaxInfo(
    getAstatDailyLocalTaxInfoRequestDTO: $getAstatDailyLocalTaxInfoRequestDTO
  ) {
    ...AstatDailyLocalTaxInfoFragment
  }
}
    ${AstatDailyLocalTaxInfoFragmentFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAstatDailyLocalTaxInfoInjectable extends Apollo.Query<GetAstatDailyLocalTaxInfoQueryResult, GetAstatDailyLocalTaxInfoQueryVariables> {
    override document = GetAstatDailyLocalTaxInfoGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */